import type { SessionHydrationState, SessionHydrator } from './session-hydration';

export type BootstrapSessionHydrationOptions = {
  recoveryAttempts?: number;
  recoveryDelayMs?: number;
  sleep?: (delayMs: number) => Promise<void>;
};

export async function bootstrapSessionHydration<User>(
  hydrator: SessionHydrator<User>,
  options: BootstrapSessionHydrationOptions = {},
): Promise<SessionHydrationState<User>> {
  let state = await hydrator.hydrate();
  const recoveryAttempts = options.recoveryAttempts ?? 2;
  const recoveryDelayMs = options.recoveryDelayMs ?? 2_000;
  const sleep =
    options.sleep ??
    ((delay: number) => new Promise<void>((resolve) => setTimeout(resolve, delay)));

  for (let attempt = 0; attempt < recoveryAttempts; attempt += 1) {
    if (!(state.status === 'anonymous' && state.error && state.recoverable)) {
      break;
    }
    await sleep(recoveryDelayMs);
    state = await hydrator.retry();
  }

  return state;
}
